<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>Ship Manpower</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Ship Manpower</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <div id="container">
        <Dropdown @change="companyChanged" v-model="company" :options="companies" optionLabel="name" dataKey="value" placeholder="Company" :required="true" :filter="true" filterPlaceholder="Company" />
        <ion-item>
            <ion-label position="floating">Client <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" @IonChange="clientChanged" v-model="postData['client_id']">
                <ion-select-option v-for="(client,i) of clients" :key="i" :value="client.id">{{client.client_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Ship <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="postData['ship_id']">
                <ion-select-option v-for="(ship,i) of ships" :key="i" :value="ship.id">{{ship.ship_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Staff Name <span class="required">*</span></ion-label>
            <ion-input mode="ios" v-model="postData['worker_name']"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Staff Name In Bangla</ion-label>
            <ion-input mode="ios" v-model="postData['worker_name_bn']"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Gender <span class="required">*</span></ion-label>
            <ion-select mode="ios"  v-model="postData['gender']" interface="action-sheet">
                <ion-select-option value="Male">Male</ion-select-option>
                <ion-select-option value="Female">Female</ion-select-option>
                <ion-select-option value="Other">Other</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Blood Group</ion-label>
            <ion-select mode="ios"  v-model="postData['blood_group']" interface="action-sheet">
                <ion-select-option v-for="(bloodGroup,i) of bloodGroups" :key="i" :value="bloodGroup">{{bloodGroup}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Education Level</ion-label>
            <ion-select mode="ios"  v-model="postData['education_level']" interface="action-sheet">
                <ion-select-option v-for="(education,i) of educations" :key="i" :value="education">{{education}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Mobile <span class="required">*</span></ion-label>
            <ion-input mode="ios" v-model="postData['worker_mobile']" type="tel"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">NID</ion-label>
            <ion-input mode="ios" v-model="postData['worker_nid']"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Father Name <span class="required">*</span></ion-label>
            <ion-input mode="ios" v-model="postData['father_name']"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Mother Name <span class="required">*</span></ion-label>
            <ion-input mode="ios" v-model="postData['mother_name']"></ion-input>
        </ion-item>
        <ion-item>
        <ion-label position="floating">Date Of Birth</ion-label>
        <ion-datetime mode="ios" v-model="postData['worker_dob']" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
      </ion-item>
        <ion-item>
            <ion-label position="floating">Address <span class="required">*</span></ion-label>
            <ion-input mode="ios" v-model="postData['address']"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Country <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" @IonChange="countryChanged" v-model="postData['country_id']">
                <ion-select-option v-for="(country,i) of countries" :key="i" :value="country.id">{{country.country_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Division <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" @IonChange="devisionChanged" v-model="postData['division_id']">
                <ion-select-option v-for="(division,i) of divisions" :key="i" :value="division.id">{{division.division_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">District <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" @IonChange="districtChanged" v-model="postData['district_id']">
                <ion-select-option v-for="(district,i) of districts" :key="i" :value="district.id">{{district.district_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Upozilla <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="postData['upozilla_id']">
                <ion-select-option v-for="(upozilla,i) of upozillas" :key="i" :value="upozilla.id">{{upozilla.upozilla_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Marital Status</ion-label>
            <ion-select mode="ios"  v-model="postData['marital_status']" interface="action-sheet">
                <ion-select-option value="Unmarried">Unmarried</ion-select-option>
                <ion-select-option value="Married">Married</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Spouse Name</ion-label>
            <ion-input mode="ios" :disabled="postData['marital_status']!='Married'" v-model="postData['spouse_name']"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Post In Ship <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="postData['worker_post_id']">
                <ion-select-option v-for="(workerPost,i) of workerPosts" :key="i" :value="workerPost.id">{{workerPost.worker_post_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Working This Ship Since <span class="required">*</span></ion-label>
            <ion-datetime mode="ios" v-model="postData['current_ship_working_since']" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
        </ion-item>
        <ion-item>
          <ion-button @click="takePicture()" color="primary">Take Picture</ion-button>
        </ion-item>
        <ion-item v-if="postData['worker_picture']!=null">
          <ion-img :src="'data:image/jpeg;base64,'+postData['worker_picture']"></ion-img>
        </ion-item>
        <div v-for="(ex,j) of postData['working_experience']" :key="j">
          <ion-item>
            <ion-text>
              <h5>Working Experience-{{j+1}}:</h5>
            </ion-text>
            <ion-button color="danger" @click="removeExperience(j)" v-if="j>0">
              Remove
            </ion-button>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Previous Position</ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="postData['working_experience'][j]['previous_position']">
                <ion-select-option v-for="(workerPost,i) of workerPosts" :key="i" :value="workerPost.id">{{workerPost.worker_post_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Working Year</ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="postData['working_experience'][j]['working_year']">
                <ion-select-option v-for="year of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]" :key="year" :value="year">{{year}}</ion-select-option>
            </ion-select>
        </ion-item>
        </div>
        <ion-item>
          <ion-button @click="addMoreWoringExperience()" color="secondary">Add More Working Experience</ion-button>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Mobile Banking Name</ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="postData['mobile_banking_id']">
                <ion-select-option v-for="(mobileBanking,i) of mobileBankings" :key="i" :value="mobileBanking.id">{{mobileBanking.mobile_banking_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item v-if="postData['mobile_banking_id']!=''">
            <ion-label position="floating">Mobile Banking Number <span class="required">*</span></ion-label>
            <ion-input mode="ios" v-model="postData['mobile_banking_number']" type="tel"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Worker Certificate Name</ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="postData['worker_certificate_id']">
                <ion-select-option v-for="(workerCertificate,i) of workerCertificates" :key="i" :value="workerCertificate.id">{{workerCertificate.worker_certificate_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item v-if="postData['worker_certificate_id']!=''">
            <ion-label position="floating">Worker Certificate Number <span class="required">*</span></ion-label>
            <ion-input mode="ios" v-model="postData['worker_certificate_number']" type="number"></ion-input>
        </ion-item>
        <ion-button expand="block" @click="save()" color="primary">Save</ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script >
import { IonButtons, IonButton, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonInput, IonItem, IonLabel,IonSelect,IonSelectOption,IonImg,IonDatetime,alertController, IonText } from '@ionic/vue';
import { Camera, CameraResultType } from '@capacitor/camera';
import Loading from '../Loading';
import Dropdown from './modules/Dropdown.vue';
export default {
  name: 'Client Register',
  data(){
    return {
    countries:[],
    divisions:[],
    districts:[],
    upozillas:[],
    companies:[],
    bloodGroups:["A+","A-","B+","B-","AB+","AB-","O+","O-"],
    educations:["Masters","Bachelors","HSC","SSC","9",'8','7','6','5','4','3','2','1','None'],
    company:'',
    clients:[],
    ships:[],
    workerPosts:[],
    mobileBankings:[],
    workerCertificates:[],
      postData:{
            'company_id':null,
            'client_id':null,
            'ship_id':null,
            'worker_name':'',
            'worker_name_bn':'',
            'gender':'',
            'blood_group':'',
            'education_level':'',
            'working_experience':[
              {
                'previous_position':null,
                'working_year':null
              }
            ],
            'mobile_banking_id':'',
            'mobile_banking_number':'',
            'worker_certificate_id':'',
            'worker_certificate_number':'',
            'worker_mobile':'',
            'worker_nid':'',
            'father_name':'',
            'mother_name':'',
            'worker_dob':'',
            'address':'',
            'country_id':null,
            'division_id':null,
            'district_id':null,
            'upozilla_id':null,
            'marital_status':'',
            'spouse_name':'',
            'worker_post_id':null,
            'current_ship_working_since':'',
            'worker_picture':null,
        }
    }
  },
  created(){
    this.$http.get('getCountries',).then(response=>{
      this.countries=response.data;
    });
    this.$http.get('getWorkerPost',).then(response=>{
      this.workerPosts=response.data;
    });
    this.$http.get('getMobileBanking',).then(response=>{
      this.mobileBankings=response.data;
    });
    this.$http.get('getWorkerCertificate',).then(response=>{
      this.workerCertificates=response.data;
    });
    this.$http.get('getCompany',).then(response=>{
        const coms=[];
        for(const com of response.data){
            coms.push({
                name:com.company_name,
                value:com.id
            });
        }
      this.companies=coms;
    });
  },
  methods:{
    clearDateTime(event){
      event.target.value='';
    },
    removeTimeString(date){
      if(date=='' || date==null){
        return '';
      }
      return new Date(date).toISOString().split('T')[0];
    },
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
    async save(){
        const requireds=[
            'company_id',
            'client_id',
            'ship_id',
            'worker_name',
            'gender',
            'worker_mobile',
            'father_name',
            'mother_name',
            'address',
            'country_id',
            'division_id',
            'district_id',
            'upozilla_id',
            'worker_post_id',
            'current_ship_working_since',
            'worker_picture',
            'company_id',
        ];
        for(const required of requireds){
            if(this.postData[required]=='' || this.postData[required]==null){
                let name=required;
                name=name.replace('_id','');
                name=name.replace('_',' ');
                this.presentAlert(name);
                return;
            }
        }
        if(this.postData.worker_certificate_id!='' && this.postData.worker_certificate_number==''){
          this.presentAlert('Worker Certificate Number');
                return;
        }
        if(this.postData.mobile_banking_id!='' && this.postData.mobile_banking_number==''){
          this.presentAlert('Mobile Banking Number');
                return;
        }else if(this.postData.mobile_banking_id!='' && this.postData.mobile_banking_number.length!=11){
          this.presentResponseAlert('Alert','Mobile Banking Number must be 11 digit');
          return;
        }
        if(this.postData.worker_mobile.length!=11){
          this.presentResponseAlert('Alert','Mobile must be 11 digit');
          return;
        }
        const data=this.postData;
        data['worker_dob']=this.removeTimeString(data.worker_dob);
        data['current_ship_working_since']=this.removeTimeString(data.current_ship_working_since);
        data['username'] = window.localStorage.username,
        data['password'] = window.localStorage.password,
      this.$http.post('workerAdd',data).then(response=>{
        if(response.status==200){
            this.postData={
            'company_id':this.postData.company_id,
            'client_id':this.postData.client_id,
            'ship_id':this.postData.ship_id,
            'worker_name':'',
            'worker_name_bn':'',
            'gender':'',
            'blood_group':'',
            'education_level':'',
            'working_experience':[
              {
                'previous_position':null,
                'working_year':null
              }
            ],
            'mobile_banking_id':'',
            'mobile_banking_number':'',
            'worker_certificate_id':'',
            'worker_certificate_number':'',
            'worker_mobile':'',
            'worker_nid':'',
            'father_name':'',
            'mother_name':'',
            'worker_dob':'',
            'address':'',
            'country_id':null,
            'division_id':null,
            'district_id':null,
            'upozilla_id':null,
            'marital_status':'',
            'spouse_name':'',
            'worker_post_id':null,
            'current_ship_working_since':'',
            'worker_picture':null,
        }
          this.presentResponseAlert('Success','Worker added Successfully');
          
        }
      });      
    },
    async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message+" is required",
          buttons: ['OK'],
        });
      await alert.present();

    },
   async takePicture() {
      const image = await Camera.getPhoto({
      quality: 90,
      height:720,
      allowEditing: false,
      resultType: CameraResultType.Base64
      });
    
    this.postData['worker_picture'] = image.base64String;

    },
    async companyChanged(){
        const loading = await Loading.presentLoading('Loading');
        this.postData['company_id']=this.company.value;
        this.postData['client_id']=null;
        this.$http.get('getClient',{params:{id:this.company.value}}).then(response=>{
            this.clients=response.data;
            loading.dismiss();
        });
    },
    async clientChanged(){
        this.postData['ship_id']=null;
        const loading = await Loading.presentLoading('Loading');
        this.$http.get('getShip',{params:{id:this.postData['client_id']}}).then(response=>{
            this.ships=response.data;
            loading.dismiss();
        });
    },
    countryChanged(){
      for(const country of this.countries){
        if(this.postData['country_id']==country.id){
          this.divisions=country.division;
          break;
        }
      }
    },
    devisionChanged(){
      for(const division of this.divisions){
        if(this.postData['division_id']==division.id){
          this.districts=division.districts;
          break;
        }
      }
    },
    districtChanged(){
      for(const district of this.districts){
        if(this.postData['district_id']==district.id){
          this.upozillas=district.upozilla;
          break;
        }
      }
    },
    addMoreWoringExperience(){
      this.postData.working_experience.push({
                'previous_position':null,
                'working_year':null
              });
    },
    removeExperience(j){
      const ex=[];
      for(let i=0;i<this.postData.working_experience.length;i++){
        if(i!=j){
          ex.push(this.postData.working_experience[i]);
        }
      }
      this.postData['working_experience']=ex;
    }
  },
  components: {
    IonButtons,
    IonButton,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonInput,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonImg,
    IonDatetime,
    Dropdown,
    IonText
  }
  
}
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  /* top: 50%; */
  /* transform: translateY(-50%); */
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
.p-dropdown{
width: 100%;
color:#000;
}
.required{
  color:rgb(233, 0, 0)
}
</style>